"use client"

import * as React from "react"
import { ArrowLeft, ArrowRight } from "lucide-react"

import { cn } from '@/utils/index'
import { Button } from "@/components/atoms/Button/button"
import { useCarousel } from "@/contexts/CarouselContext"

type Direction = "prev" | "next"

interface NavigationProps extends React.ComponentProps<typeof Button> {
  direction: Direction
}

export const CarouselNavigation = React.forwardRef<HTMLButtonElement, NavigationProps>(
  ({ direction, className, ...props }, ref) => {
    const { scrollPrev, scrollNext, canScrollPrev, canScrollNext } = useCarousel()

    const isPrev = direction === "prev"
    const handleClick = isPrev ? scrollPrev : scrollNext
    const isDisabled = isPrev ? !canScrollPrev : !canScrollNext

    return (
      <button
        ref={ref}
        variant="secondary"
        size="lg"
        className={cn(
          "absolute flex size-12 items-center justify-center rounded-full bg-gray-950 text-white transition-transform hover:scale-105 hover:bg-gray-700",
          isPrev ? "left-4" : "right-4",
          className
        )}
        disabled={isDisabled}
        onClick={handleClick}
        {...props}
      >
        {isPrev ? <ArrowLeft className={cn("size-4")} /> : <ArrowRight className={cn("size-4")} />}
        <span className="sr-only">{isPrev ? "Previous slide" : "Next slide"}</span>
      </button>
    )
  }
)

CarouselNavigation.displayName = "CarouselNavigation"
